var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBizzBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6565 39.7869C48.5281 41.2925 47.3382 42.4763 45.8535 42.5718C43.0375 42.7528 38.0853 43 32.0378 43C25.9964 43 21.0479 42.7534 18.2305 42.5723C16.7513 42.4772 15.5626 41.3022 15.4289 39.8026C15.2349 37.6283 15 34.4918 15 32.0529C15 29.6009 15.2375 26.4068 15.4321 24.2011C15.5644 22.7 16.7535 21.5226 18.234 21.4275C21.052 21.2466 25.9989 21 32.0378 21C38.0824 21 43.0329 21.2471 45.8496 21.428C47.3339 21.5235 48.5254 22.7066 48.6526 24.2118C48.8174 26.1622 49 29.0111 49 32.0529C49 35.0703 48.8202 37.8665 48.6565 39.7869H48.6565Z",
    stroke: "#193232",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0236 30.9509C40.8177 30.9509 38.2188 28.352 38.2188 25.146",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0243 34.2679C38.9863 34.2679 34.9023 30.184 34.9023 25.146",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.024 37.585C37.154 37.585 31.585 32.0158 31.585 25.146",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizzBig);
export default __webpack_public_path__ + "static/media/bizz-big.8fc8b038e82cf4db4d5bb6e58b2ddb4d.svg";
export { ForwardRef as ReactComponent };